module.exports = __webpack_public_path__ + "img/defaultAppLogo.5551a1ec.png";